<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>GUIDE UTILISATEUR</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>GUIDE UTILISATEUR</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main Content -->
<section class="main-content pt-100">
    <div class="container pb-100">
        <!-- Shimmer effect pendant le chargement -->
        <ng-container *ngIf="loading">
            <div class="row" *ngFor="let item of [].constructor(3)">
                <div class="col-lg-12 mb-4">
                    <div class="guide-skeleton">
                        <div class="skeleton-header">
                            <p-skeleton height="2.5rem" width="60%" styleClass="mb-3"></p-skeleton>
                        </div>
                        <div class="skeleton-content">
                            <div class="row">
                                <div class="col-lg-3">
                                    <p-skeleton height="200px" width="100%" styleClass="mb-3"></p-skeleton>
                                </div>
                                <div class="col-lg-9">
                                    <p-skeleton height="2rem" width="40%" styleClass="mb-3"></p-skeleton>
                                    <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                                    <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                                    <p-skeleton width="90%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                                    <p-skeleton width="95%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        
        <!-- Contenu réel après chargement -->
        <ng-container *ngIf="!loading && guides">
            <div class="row" *ngFor="let guideline of guides">
                <div class="col-lg-12 mb-4">
                    <div class="guide-card">
                        <div class="guide-header">
                            <div class="guide-icon">
                                <i class="icofont-book"></i>
                            </div>
                            <h2 class="guide-title">{{ guideline.name }}</h2>
                        </div>
                        
                        <div class="guide-content">
                            <div class="row">
                                <div class="col-lg-3 mb-4 mb-lg-0">
                                    <div class="guide-image">
                                        <img [src]="guideline.content.media" [alt]="guideline.content.title" />
                                    </div>
                                </div>
                                
                                <div class="col-lg-9">
                                    <div class="guide-details">
                                        <h3 class="guide-subtitle">{{ guideline.content.title }}</h3>
                                        <div class="guide-description" [innerHTML]="guideline.content.description"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        
        
    </div>
    <!-- CTA Section -->
    <div class="row mt-5" *ngIf="!loading">
        <div class="col-lg-12 text-center">
            <div class="cta-section">
                <h3>Prêt à rejoindre BSTP ?</h3>
                <p>Adhérez maintenant et accédez à tous nos guides et ressources exclusives</p>
                <a routerLink="/create-account" class="btn btn-primary">
                    <i class="icofont-user-plus"></i>
                    J'ADHÈRE MAINTENANT
                </a>
            </div>
        </div>
    </div>
</section>
